import React from "react";

export const Like = () => (
  <svg width="24px" height="24px" viewBox="0 0 24 24">
    <g
      id="icon/like/idle"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g id="icon">
        <rect id="frame" x="0" y="0" width="24" height="24"></rect>
        <g
          id="like"
          transform="translate(4.000000, 4.000000)"
          fill="#4A5768"
          fill-rule="nonzero"
        >
          <path
            d="M15.8333333,7.04333333 C15.8322316,6.215363 15.1613037,5.54443509 14.3333333,5.54333333 L9.84933333,5.54333333 C9.79852699,5.54340503 9.75046247,5.52029855 9.71878733,5.48057481 C9.68711219,5.44085107 9.67528598,5.38884868 9.68666667,5.33933333 C9.94679598,4.30705159 10.1075288,3.25224235 10.1666667,2.18933333 C10.195504,1.63317729 10.0155141,1.08631255 9.662,0.656 C9.36741309,0.320137124 8.94340334,0.126082319 8.49666667,0.122666667 C8.15219673,0.105406733 7.81558377,0.22936178 7.56457388,0.465902427 C7.31356399,0.702443073 7.16986507,1.03111276 7.16666667,1.376 C7.19208348,3.92810654 5.21406262,6.05294051 2.66666667,6.21 L0.666666667,6.21 C0.390524292,6.21 0.166666667,6.43385763 0.166666667,6.71 L0.166666667,12.71 C0.166666667,12.9861424 0.390524292,13.21 0.666666667,13.21 C3.688,13.21 4.67266667,13.6333333 5.54133333,14.0053333 C6.30660576,14.37717 7.14937,14.5615818 8,14.5433333 L12.3333333,14.5433333 C12.8514855,14.5430717 13.3328458,14.2755261 13.6066366,13.8356166 C13.8804274,13.3957071 13.9079097,12.845677 13.6793333,12.3806667 C14.4112647,12.0086317 14.7083241,11.1174535 14.346,10.3806667 C15.0779314,10.0086317 15.3749908,9.11745346 15.0126667,8.38066667 C15.5160433,8.12479399 15.833173,7.60800924 15.8333333,7.04333333 Z"
            id="Path"
          ></path>
        </g>
      </g>
    </g>
  </svg>
);

export const Reply = () => (
  <svg width="24px" height="24px" viewBox="0 0 24 24">
    <g
      id="icon/reply/idle"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g id="icon">
        <rect id="frame" x="0" y="0" width="24" height="24"></rect>
        <g
          id="email-action-reply"
          transform="translate(4.000000, 7.000000)"
          fill="#4A5768"
          fill-rule="nonzero"
        >
          <path
            d="M12.6940926,4.58352521 C10.6411396,2.73273322 7.83614171,2.60588118 6.65386987,2.64747201 C6.60755543,2.6493651 6.56249346,2.63192364 6.52914343,2.59919601 C6.4957934,2.56646838 6.47705552,2.52130066 6.47727909,2.47417688 L6.47727909,0.691316579 C6.47656448,0.422392753 6.32292086,0.178156629 6.08309376,0.0647087003 C5.84326665,-0.0487392286 5.56053969,-0.0109240472 5.35773447,0.161726661 L0.24819283,4.57451386 C0.0909838001,4.7062395 0,4.90253344 0,5.10964923 C-0.00114013823,5.31267634 0.0865517532,5.50571487 0.2393292,5.63646642 L5.36182538,10.2371055 C5.56558917,10.4078399 5.84799817,10.4436117 6.08673938,10.328928 C6.32548058,10.2142443 6.47762543,9.96972663 6.47727909,9.701277 L6.47727909,7.59747412 C6.47732166,7.51527661 6.53437344,7.44451348 6.61364262,7.42833807 C7.91455074,7.15106586 12.1602294,6.62563503 14.3590914,10.8179908 C14.4330902,10.9573844 14.5906267,11.0280369 14.7417779,10.9896194 C14.892929,10.9512018 14.9992286,10.8134911 15,10.6550934 C15,8.00645063 14.2240915,5.96434081 12.6940926,4.58352521 Z"
            id="Path"
          ></path>
        </g>
      </g>
    </g>
  </svg>
);

export const View = () => (
  <svg width="24px" height="24px" viewBox="0 0 24 24">
    <g
      id="icon/view"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g id="icon">
        <rect id="frame" x="0" y="0" width="24" height="24"></rect>
        <g
          id="view-1"
          transform="translate(4.000000, 7.000000)"
          fill="#4A5768"
          fill-rule="nonzero"
        >
          <path
            d="M15.6213333,4.34933333 C13.858,2.40933333 10.9333333,0.358666667 8,0.4 C5.06666667,0.358 2.142,2.41 0.378666667,4.34933333 C-0.121793689,4.90886502 -0.121793689,5.75513498 0.378666667,6.31466667 C2.12133333,8.234 5.00466667,10.2666667 7.89266667,10.2666667 L8.098,10.2666667 C10.996,10.2666667 13.8786667,8.234 15.6233333,6.314 C16.1231308,5.75417789 16.1222696,4.90813672 15.6213333,4.34933333 Z M4.93333333,5.33333333 C4.93333333,3.6396601 6.30632677,2.26666667 8,2.26666667 C9.69367323,2.26666667 11.0666667,3.6396601 11.0666667,5.33333333 C11.0666667,7.02700657 9.69367323,8.4 8,8.4 C6.30632677,8.4 4.93333333,7.02700657 4.93333333,5.33333333 Z"
            id="Shape"
          ></path>
          <circle id="Oval" cx="8" cy="5.33333333" r="1.33333333"></circle>
        </g>
      </g>
    </g>
  </svg>
);

export const Share = () => (
  <svg width="24px" height="24px" viewBox="0 0 24 24">
    <g
      id="icon/share"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g id="icon">
        <rect id="frame" x="0" y="0" width="24" height="24"></rect>
        <g id="ic-share-24px" transform="translate(4.000000, 4.000000)">
          <polygon id="Path" points="0 0 16 0 16 16 0 16"></polygon>
          <path
            d="M12,10.72 C11.4933333,10.72 11.04,10.92 10.6933333,11.2333333 L5.94,8.46666667 C5.97333333,8.31333333 6,8.16 6,8 C6,7.84 5.97333333,7.68666667 5.94,7.53333333 L10.64,4.79333333 C11,5.12666667 11.4733333,5.33333333 12,5.33333333 C13.1066667,5.33333333 14,4.44 14,3.33333333 C14,2.22666667 13.1066667,1.33333333 12,1.33333333 C10.8933333,1.33333333 10,2.22666667 10,3.33333333 C10,3.49333333 10.0266667,3.64666667 10.06,3.8 L5.36,6.54 C5,6.20666667 4.52666667,6 4,6 C2.89333333,6 2,6.89333333 2,8 C2,9.10666667 2.89333333,10 4,10 C4.52666667,10 5,9.79333333 5.36,9.46 L10.1066667,12.2333333 C10.0733333,12.3733333 10.0533333,12.52 10.0533333,12.6666667 C10.0533333,13.74 10.9266667,14.6133333 12,14.6133333 C13.0733333,14.6133333 13.9466667,13.74 13.9466667,12.6666667 C13.9466667,11.5933333 13.0733333,10.72 12,10.72 Z"
            id="Path"
            fill="#4A5768"
            fill-rule="nonzero"
          ></path>
        </g>
      </g>
    </g>
  </svg>
);

export const Edit = () => (
  <svg width="24px" height="24px" viewBox="0 0 24 24">
    <g
      id="icon/edit"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g id="icon">
        <rect id="frame" x="0" y="0" width="24" height="24"></rect>
        <g
          id="pencil"
          transform="translate(4.000000, 4.000000)"
          fill="#4A5768"
          fill-rule="nonzero"
        >
          <path
            d="M10.7913333,2.34066667 C10.6591682,2.21545812 10.4521651,2.21545812 10.32,2.34066667 L2.71133333,9.94933333 C2.58120602,10.0795 2.58120602,10.2905 2.71133333,10.4206667 L5.56466667,13.274 C5.69483328,13.4041273 5.90583338,13.4041273 6.036,13.274 L13.6446667,5.66666667 C13.774794,5.53650005 13.774794,5.32549995 13.6446667,5.19533333 L10.7913333,2.34066667 Z"
            id="Path"
          ></path>
          <path
            d="M2,11.14 C1.91788248,11.0583687 1.79928572,11.0251996 1.68673414,11.052386 C1.57418256,11.0795724 1.48380216,11.163219 1.448,11.2733333 L0.0213333333,15.5533333 C-0.0188178985,15.673079 0.0121555771,15.8052325 0.101333333,15.8946667 C0.191241898,15.9829662 0.322742181,16.0140434 0.442666667,15.9753333 L4.72266667,14.5493333 C4.83304736,14.5136377 4.9169304,14.4231207 4.94413751,14.3103472 C4.97134461,14.1975738 4.93796215,14.0787659 4.856,13.9966667 L2,11.14 Z"
            id="Path"
          ></path>
          <path
            d="M15.312,0.678 C14.3813546,-0.209874695 12.9173121,-0.209874695 11.9866667,0.678 L11.512,1.15333333 C11.3818727,1.28349995 11.3818727,1.49450005 11.512,1.62466667 L14.3646667,4.478 C14.4948333,4.60812731 14.7058334,4.60812731 14.836,4.478 L15.312,4 C16.226964,3.08167009 16.226964,1.59632991 15.312,0.678 L15.312,0.678 Z"
            id="Path"
          ></path>
        </g>
      </g>
    </g>
  </svg>
);

export const Delete = () => (
  <svg width="24px" height="24px" viewBox="0 0 24 24">
    <g
      id="icon/delete"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g id="icon">
        <rect id="frame" x="0" y="0" width="24" height="24"></rect>
        <g
          id="bin"
          transform="translate(4.000000, 4.000000)"
          fill="#4A5768"
          fill-rule="nonzero"
        >
          <path
            d="M12.3333333,5 L2.33333333,5 C2.14923842,5 2,5.14923842 2,5.33333333 L2,14.6666667 C2,15.4030463 2.59695367,16 3.33333333,16 L11.3333333,16 C12.069713,16 12.6666667,15.4030463 12.6666667,14.6666667 L12.6666667,5.33333333 C12.6666667,5.14923842 12.5174282,5 12.3333333,5 Z M6.16666667,13.6666667 C6.16666667,13.942809 5.94280904,14.1666667 5.66666667,14.1666667 C5.39052429,14.1666667 5.16666667,13.942809 5.16666667,13.6666667 L5.16666667,7.66666667 C5.16666667,7.39052429 5.39052429,7.16666667 5.66666667,7.16666667 C5.94280904,7.16666667 6.16666667,7.39052429 6.16666667,7.66666667 L6.16666667,13.6666667 Z M9.5,13.6666667 C9.5,13.942809 9.27614237,14.1666667 9,14.1666667 C8.72385763,14.1666667 8.5,13.942809 8.5,13.6666667 L8.5,7.66666667 C8.5,7.39052429 8.72385763,7.16666667 9,7.16666667 C9.27614237,7.16666667 9.5,7.39052429 9.5,7.66666667 L9.5,13.6666667 Z"
            id="Shape"
          ></path>
          <path
            d="M14,2.66666667 L10.8333333,2.66666667 C10.7412859,2.66666667 10.6666667,2.59204746 10.6666667,2.5 L10.6666667,1.66666667 C10.6666667,0.746192084 9.92047458,0 9,0 L5.66666667,0 C4.74619208,0 4,0.746192084 4,1.66666667 L4,2.5 C4,2.54420275 3.98244053,2.58659507 3.95118446,2.61785113 C3.9199284,2.64910719 3.87753608,2.66666667 3.83333333,2.66666667 L0.666666667,2.66666667 C0.298476833,2.66666667 0,2.9651435 0,3.33333333 C0,3.70152317 0.298476833,4 0.666666667,4 L14,4 C14.3681898,4 14.6666667,3.70152317 14.6666667,3.33333333 C14.6666667,2.9651435 14.3681898,2.66666667 14,2.66666667 Z M5.33333333,2.5 L5.33333333,1.66666667 C5.33333333,1.48257175 5.48257175,1.33333333 5.66666667,1.33333333 L9,1.33333333 C9.18409492,1.33333333 9.33333333,1.48257175 9.33333333,1.66666667 L9.33333333,2.5 C9.33333333,2.59204746 9.25871412,2.66666667 9.16666667,2.66666667 L5.5,2.66666667 C5.40795254,2.66666667 5.33333333,2.59204746 5.33333333,2.5 Z"
            id="Shape"
          ></path>
        </g>
      </g>
    </g>
  </svg>
);

//DV start screen

export const Column = () => (
  <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1">
    <g
      id="icon/chart-type/16/column"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g id="Group" fill="#7B8998">
        <rect id="Rectangle" x="0" y="15" width="16" height="1"></rect>
        <rect id="Rectangle" x="0" y="0" width="1" height="16"></rect>
        <rect id="Rectangle" x="13" y="8" width="3" height="7"></rect>
        <rect id="Rectangle" x="8" y="2" width="3" height="13"></rect>
        <rect id="Rectangle" x="3" y="4" width="3" height="11"></rect>
      </g>
    </g>
  </svg>
);

export const Line = () => (
  <svg width="16px" height="16px" viewBox="0 0 16 16">
    <defs>
      <rect id="path-1" x="0" y="0" width="16" height="16"></rect>
    </defs>
    <g
      id="icon/chart-type/16/line"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g id="Group">
        <g id="Rectangle"></g>
        <rect
          id="Rectangle"
          fill="#7B8998"
          mask="url(#mask-2)"
          x="0"
          y="15"
          width="16"
          height="1"
        ></rect>
        <rect
          id="Rectangle"
          fill="#7B8998"
          mask="url(#mask-2)"
          x="0"
          y="0"
          width="1"
          height="16"
        ></rect>
        <polyline
          id="Path"
          stroke="#7B8998"
          stroke-width="1.5"
          mask="url(#mask-2)"
          points="0 5 5 9 9 7 15 12"
        ></polyline>
      </g>
    </g>
  </svg>
);

export const PivotTable = () => (
  <svg width="16px" height="16px" viewBox="0 0 16 16">
    <g
      id="icon/chart-type/16/pivot-table"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g id="icon-no-bg">
        <polygon
          id="Rectangle-2"
          fill="#7B8998"
          points="1 11 15 11 15 12 1 12"
        ></polygon>
        <polygon
          id="Rectangle-2"
          fill="#7B8998"
          points="6 1 7 1 7 15 6 15"
        ></polygon>
        <polygon
          id="Rectangle-2"
          fill="#7B8998"
          points="1 6 15 6 15 7 1 7"
        ></polygon>
        <rect
          id="Rectangle-2"
          stroke="#7B8998"
          x="0.5"
          y="0.5"
          width="15"
          height="15"
        ></rect>
      </g>
    </g>
  </svg>
);

export const SingleValue = () => (
  <svg width="16px" height="16px" viewBox="0 0 16 16">
    <g
      id="icon/chart-type/16/single-value"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <path
        d="M3.85595703,11 L2.37060547,11 L2.37060547,6.27148438 L0.911621094,6.69775391 L0.911621094,5.57275391 L3.71972656,4.6015625 L3.85595703,4.6015625 L3.85595703,11 Z M10.25,11 L5.78515625,11 L5.78515625,10.0332031 L7.84179688,7.87109375 C8.34863535,7.29394243 8.60205078,6.83545092 8.60205078,6.49560547 C8.60205078,6.22021347 8.54199279,6.01074291 8.421875,5.8671875 C8.30175721,5.72363209 8.12744255,5.65185547 7.89892578,5.65185547 C7.67333872,5.65185547 7.49023508,5.74780177 7.34960938,5.93969727 C7.20898367,6.13159276 7.13867188,6.37109231 7.13867188,6.65820312 L5.65332031,6.65820312 C5.65332031,6.26562304 5.75146386,5.90307783 5.94775391,5.57055664 C6.14404395,5.23803545 6.41650216,4.97802828 6.76513672,4.79052734 C7.11377127,4.60302641 7.50341582,4.50927734 7.93408203,4.50927734 C8.62549174,4.50927734 9.15795712,4.66894372 9.53149414,4.98828125 C9.90503116,5.30761878 10.0917969,5.76611029 10.0917969,6.36376953 C10.0917969,6.61572392 10.0449223,6.86108279 9.95117188,7.09985352 C9.85742141,7.33862424 9.71167091,7.58911002 9.51391602,7.85131836 C9.31616112,8.1135267 8.99756079,8.46435327 8.55810547,8.90380859 L7.73193359,9.85742188 L10.25,9.85742188 L10.25,11 Z M12.3505859,7.18115234 L13.0493164,7.18115234 C13.6030301,7.18115234 13.8798828,6.91015896 13.8798828,6.36816406 C13.8798828,6.15722551 13.8139655,5.98510809 13.6821289,5.85180664 C13.5502923,5.71850519 13.364259,5.65185547 13.1240234,5.65185547 C12.9277334,5.65185547 12.7570808,5.7089838 12.6120605,5.82324219 C12.4670403,5.93750057 12.3945312,6.07958899 12.3945312,6.24951172 L10.9135742,6.24951172 C10.9135742,5.91259597 11.0073233,5.61230601 11.1948242,5.34863281 C11.3823252,5.08495962 11.6423323,4.87915113 11.9748535,4.73120117 C12.3073747,4.58325121 12.6728496,4.50927734 13.0712891,4.50927734 C13.7832067,4.50927734 14.3427714,4.67187337 14.75,4.99707031 C15.1572286,5.32226725 15.3608398,5.76904013 15.3608398,6.33740234 C15.3608398,6.61279435 15.2766122,6.87280151 15.1081543,7.11743164 C14.9396964,7.36206177 14.6943375,7.56054611 14.3720703,7.71289062 C14.7119158,7.83593812 14.9785147,8.02270383 15.171875,8.27319336 C15.3652353,8.52368289 15.4619141,8.83349425 15.4619141,9.20263672 C15.4619141,9.77392864 15.2421897,10.2309553 14.8027344,10.5737305 C14.3632791,10.9165056 13.7861364,11.0878906 13.0712891,11.0878906 C12.6523417,11.0878906 12.2634295,11.0080574 11.904541,10.8483887 C11.5456525,10.6887199 11.2739267,10.4675307 11.0893555,10.1848145 C10.9047842,9.9020982 10.8125,9.58056821 10.8125,9.22021484 L12.3022461,9.22021484 C12.3022461,9.41650489 12.3813469,9.58642506 12.5395508,9.72998047 C12.6977547,9.87353587 12.892577,9.9453125 13.1240234,9.9453125 C13.3847669,9.9453125 13.5927727,9.87280346 13.7480469,9.7277832 C13.9033211,9.58276295 13.980957,9.39746207 13.980957,9.171875 C13.980957,8.84960776 13.9003914,8.62109442 13.7392578,8.48632812 C13.5781242,8.35156183 13.3554702,8.28417969 13.0712891,8.28417969 L12.3505859,8.28417969 L12.3505859,7.18115234 Z"
        id="123"
        fill="#7B8998"
        fill-rule="nonzero"
      ></path>
    </g>
  </svg>
);

export const Arrow = () => (
  <svg
    width="18px"
    height="18px"
    viewBox="0 0 18 18"
    version="1.1"
    class="expand-arrow"
  >
    <g
      id="icon/arrow-parent/closed"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <polygon
        id="Shape"
        fill="#4A5768"
        fill-rule="nonzero"
        transform="translate(9.000000, 9.000000) rotate(-90.000000) translate(-9.000000, -9.000000) "
        points="6 7 9 11 12 7"
      ></polygon>
    </g>
  </svg>
);

export const FolderClosed = () => (
  <svg width="18px" height="18px" viewBox="0 0 18 18" version="1.1">
    <g
      id="icon/folder/closed"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <path
        d="M2,3.5 C1.17157288,3.5 0.5,4.17157288 0.5,5 L0.5,13 C0.5,13.8284271 1.17157288,14.5 2,14.5 L12,14.5 C12.8284271,14.5 13.5,13.8284271 13.5,13 L13.5,7 C13.5,6.17157288 12.8284271,5.5 12,5.5 L6.69098301,5.5 L5.82917961,3.7763932 C5.7444836,3.60700119 5.57135204,3.5 5.38196601,3.5 L2,3.5 Z"
        id="Path-2"
        stroke="#6E7A8A"
        fill="#D5DDE5"
      ></path>
    </g>
  </svg>
);

export const FolderOpen = () => (
  <svg width="18px" height="18px" viewBox="0 0 18 18" version="1.1">
    <g
      id="icon/folder/open"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <path
        d="M2,3.5 C1.17157288,3.5 0.5,4.17157288 0.5,5 L0.5,13 C0.5,13.8284271 1.17157288,14.5 2,14.5 L12,14.5 C12.8284271,14.5 13.5,13.8284271 13.5,13 L13.5,7 C13.5,6.17157288 12.8284271,5.5 12,5.5 L6.69098301,5.5 L5.82917961,3.7763932 C5.7444836,3.60700119 5.57135204,3.5 5.38196601,3.5 L2,3.5 Z"
        id="Path-2"
        stroke="#6E7A8A"
        fill="#A0ADBA"
      ></path>
      <path
        d="M1.53632259,13.7093809 C1.47575089,13.7941813 1.44318932,13.8957885 1.44318932,14 C1.44318932,14.2761424 1.66704695,14.5 1.94318932,14.5 L12.4853821,14.5 C12.6468577,14.5 12.7983931,14.4220172 12.8922488,14.2906191 L16.4636774,9.2906191 C16.5242491,9.20581872 16.5568107,9.10421149 16.5568107,9 C16.5568107,8.72385763 16.3329531,8.5 16.0568107,8.5 L5.5146179,8.5 C5.35314234,8.5 5.20160692,8.57798284 5.10775116,8.7093809 L1.53632259,13.7093809 Z"
        id="Path-3"
        stroke="#6E7A8A"
        fill="#FBFCFD"
      ></path>
    </g>
  </svg>
);

export const SingleUnit = () => (
  <svg width="18px" height="18px" viewBox="0 0 18 18" version="1.1">
    <g
      id="icon/single"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <rect
        id="Rectangle"
        fill="#A0ADBA"
        x="7"
        y="7"
        width="4"
        height="4"
        rx="1"
      ></rect>
    </g>
  </svg>
);

export const Hospital = () => (
  <svg width="18px" height="18px" viewBox="0 0 18 18" version="1.1">
    <g
      id="icon/folder/hospital"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <rect
        id="Rectangle"
        fill="#E1E1E4"
        x="2"
        y="2"
        width="14"
        height="8"
      ></rect>
      <rect
        id="Rectangle"
        fill="#E1E1E4"
        x="1"
        y="10"
        width="16"
        height="4"
      ></rect>
      <rect
        id="Rectangle"
        fill="#F4F4F5"
        x="1"
        y="14"
        width="16"
        height="1"
      ></rect>
      <rect
        id="Rectangle"
        fill="#7F8790"
        x="7"
        y="14"
        width="4"
        height="1"
      ></rect>
      <rect
        id="Rectangle"
        fill="#7F8790"
        x="5"
        y="15"
        width="7"
        height="1"
      ></rect>
      <rect
        id="Rectangle"
        fill="#B50F00"
        x="5"
        y="9"
        width="8"
        height="2"
      ></rect>
      <g id="windows" transform="translate(2.000000, 3.000000)" fill="#1E77BE">
        <rect id="Rectangle" x="1" y="0" width="1" height="1"></rect>
        <rect id="Rectangle" x="3" y="0" width="1" height="1"></rect>
        <rect id="Rectangle" x="5" y="0" width="1" height="1"></rect>
        <rect id="Rectangle" x="8" y="0" width="1" height="1"></rect>
        <rect id="Rectangle" x="10" y="0" width="1" height="1"></rect>
        <rect id="Rectangle" x="12" y="0" width="1" height="1"></rect>
        <rect id="Rectangle" x="1" y="2" width="1" height="1"></rect>
        <rect id="Rectangle" x="3" y="2" width="1" height="1"></rect>
        <rect id="Rectangle" x="5" y="2" width="1" height="1"></rect>
        <rect id="Rectangle" x="8" y="2" width="1" height="1"></rect>
        <rect id="Rectangle" x="10" y="2" width="1" height="1"></rect>
        <rect id="Rectangle" x="12" y="2" width="1" height="1"></rect>
        <rect id="Rectangle" x="1" y="4" width="1" height="1"></rect>
        <rect id="Rectangle" x="3" y="4" width="1" height="1"></rect>
        <rect id="Rectangle" x="5" y="4" width="1" height="1"></rect>
        <rect id="Rectangle" x="8" y="4" width="1" height="1"></rect>
        <rect id="Rectangle" x="10" y="4" width="1" height="1"></rect>
        <rect id="Rectangle" x="12" y="4" width="1" height="1"></rect>
        <rect id="Rectangle" x="1" y="6" width="1" height="1"></rect>
        <rect id="Rectangle" x="12" y="6" width="1" height="1"></rect>
        <rect id="Rectangle" x="10" y="8" width="4" height="2"></rect>
        <rect id="Rectangle" x="5" y="8" width="4" height="2"></rect>
        <rect id="Rectangle" x="0" y="8" width="4" height="2"></rect>
      </g>
    </g>
  </svg>
);

export const MoreDots = () => (
  <svg
    width="18px"
    height="18px"
    viewBox="0 0 18 18"
    version="1.1"
    class="more-dots"
  >
    <g
      id="icon/more-dots"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <path
        d="M4,7.5 C3.17,7.5 2.5,8.17 2.5,9 C2.5,9.83 3.17,10.5 4,10.5 C4.83,10.5 5.5,9.83 5.5,9 C5.5,8.17 4.83,7.5 4,7.5 Z M14,7.5 C13.17,7.5 12.5,8.17 12.5,9 C12.5,9.83 13.17,10.5 14,10.5 C14.83,10.5 15.5,9.83 15.5,9 C15.5,8.17 14.83,7.5 14,7.5 Z M9,7.5 C8.17,7.5 7.5,8.17 7.5,9 C7.5,9.83 8.17,10.5 9,10.5 C9.83,10.5 10.5,9.83 10.5,9 C10.5,8.17 9.83,7.5 9,7.5 Z"
        id="Shape"
        fill="#4A5768"
        fill-rule="nonzero"
      ></path>
    </g>
  </svg>
);
